var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.7,
    y: 215.69,
    width: 38.22,
    height: 219.27,
    fill: "#3fe2fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.16,154.07c2.15,3.68-25,54.68-49.16,69s-74,81.7-59.27,130.73S236.09,443,236.09,443l-82.21-20.33L153.07,250c0-2.44,73-42.44,73-42.44l45.73-53.51S289.42,137.41,299.16,154.07Z",
    fill: "#3fe2fd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.32,446.15a143.43,143.43,0,0,1-58.66-12.46L144,418.25a7,7,0,1,1,5.69-12.79l34.67,15.44a129.18,129.18,0,0,0,53.58,11.25l40.81-.2h.4l76-.36a19.07,19.07,0,0,0,19-19.16,19.13,19.13,0,0,0-18.83-19,7,7,0,0,1,.05-14l4.7,0a19.07,19.07,0,0,0,3-37.89,7,7,0,0,1,.05-13.83c9-1.38,15.75-9.52,15.71-18.94a18.93,18.93,0,0,0-16-18.81,7,7,0,0,1,.92-13.94l78.83-.37a19.07,19.07,0,0,0-.09-38.14h-.09l-153.55.72h0a7,7,0,0,1-6.3-10.05l24.75-51a17.23,17.23,0,0,0-29.62-17.39c-18.1,26-44.36,58.93-66.75,68.72-19.17,8.39-44.09,20.59-61.62,29.36A7,7,0,0,1,143,245.28c17.68-8.83,42.83-21.15,62.27-29.65,14.91-6.53,37.1-29.82,60.87-63.91a31.23,31.23,0,0,1,53.71,31.5L300,224.17l142.32-.67h.16a33.07,33.07,0,0,1,.15,66.14l-55.72.26a33.37,33.37,0,0,1-6.18,44.64,33.13,33.13,0,0,1-3.13,53.82,33,33,0,0,1-22.35,57.22l-75.59.36h-.4l-41.22.2Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.76,449a7,7,0,0,1-7-7l-1-219.29a7,7,0,0,1,7-7l100.22-.36h0a7,7,0,0,1,7,7l1,219.29a7,7,0,0,1-7,7L46.78,449Zm6-219.32,1,205.29,86.22-.31-1-205.29Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.31,143.64a7,7,0,0,1-3.09-.72l-41.58-20.48a7,7,0,0,1,6.19-12.56l41.58,20.48a7,7,0,0,1-3.1,13.28Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.56,114a7,7,0,0,1-7-6.86l-.92-46.34a7,7,0,0,1,14-.28l.92,46.34a7,7,0,0,1-6.86,7.14Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,141.18a7,7,0,0,1-2.5-13.54l43.32-16.5a7,7,0,1,1,5,13.08l-43.31,16.5A7.07,7.07,0,0,1,342,141.18Z",
    fill: "#251ac7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbs);
export default __webpack_public_path__ + "static/media/thumbs.a7d084d14d4e5fe3f8c5e601dd942f79.svg";
export { ForwardRef as ReactComponent };